import RepeatIcon from '@atlaskit/icon-lab/core/repeat';
import * as React from 'react';

export function SvgRepeat() {
  return <RepeatIcon label="" testId="ads-refreshed-icon" />;
}
